import { gql } from "utils/urql";
import styles from "./ArticleShare.module.scss";
import { useState } from "react";
import useClipboard from "react-use-clipboard";
import FacebookIcon from "assets/social-icons/facebook.svg";
import EmailIcon from "assets/social-icons/email.svg";
import TwitterIcon from "assets/social-icons/twitter.svg";
import CopyIcon from "assets/social-icons/copy.svg";
import { ArticleShareFragment } from "types/api";

const ArticleShare = ({
  url,
  shareDek,
  shareText,
  shareTitle,
  title,
  dek,
}: ArticleShareFragment) => {
  const copyUrl = `${url}?utm_source=copy-link&utm_medium=social&utm_campaign=share`;
  const [showKit, setShowKit] = useState(false);
  const [isCopied, setCopied] = useClipboard(copyUrl, {
    successDuration: 3000,
  });

  return (
    <div className={styles.root}>
      <button
        className={styles.shareButton}
        onClick={() => (showKit ? setShowKit(false) : setShowKit(true))}
        aria-haspopup={true}
        aria-controls={"expanded-share-kit"}
        aria-expanded={showKit}
        aria-label={showKit ? "Close Share Menu" : "Open Share Menu"}
        data-action={
          showKit ? "click share - collapse" : "click share - expand"
        }
      >
        Share
      </button>

      {showKit && (
        <ul className={styles.shareContainer} id="expanded-share-kit">
          {/* Facebook Link */}
          <li className={styles.shareItem}>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${url}%3Futm_source%3Dfacebook%26utm_medium%3Dsocial%26utm_campaign%3Dshare`}
              target="_blank"
              rel="noopener noreferrer"
              data-action="click share - facebook"
            >
              <FacebookIcon className={styles.icon} title="Facebook" />
            </a>
          </li>

          {/* Twitter Link */}
          <li className={styles.shareItem}>
            <a
              href={`https://twitter.com/intent/tweet?text=${
                shareText || title
              }&url=${url}%3Futm_source%3Dtwitter%26utm_medium%3Dsocial%26utm_campaign%3Dshare`}
              target="_blank"
              rel="noopener noreferrer"
              data-action="click share - twitter"
            >
              <TwitterIcon className={styles.icon} title="Twitter" />
            </a>
          </li>

          {/* Copy Link */}
          <li className={styles.shareItem}>
            <button
              className={styles.copyText}
              onClick={setCopied}
              data-action="click share - copy url"
              data-label={copyUrl}
            >
              <CopyIcon className={styles.icon} title="Copy to clipboard" />
            </button>
            {isCopied && (
              <div className={styles.copySuccessContainer}>
                <span className={styles.copySuccess}>Link Copied</span>
              </div>
            )}
          </li>

          {/* Email Link */}
          <li className={styles.shareItem}>
            <a
              href={`mailto:?subject=${shareTitle || title}&body=${
                shareDek || dek
              }%20${url}%3Futm_source%3Demail%26utm_medium%3Dsocial%26utm_campaign%3Dshare`}
              target="_blank"
              rel="noopener noreferrer"
              data-action="click share - email"
            >
              <EmailIcon className={styles.icon} title="Email" />
            </a>
          </li>
        </ul>
      )}
    </div>
  );
};

export default ArticleShare;

ArticleShare.fragment = gql`
  fragment articleShare on Article {
    url
    shareDek
    shareText
    shareTitle
    dek
    title
  }
`;
